<script setup>
import JobProcessingProgress from "@/components/ai-processing/JobProcessingProgress.vue";
import {StepSummaryConfig} from "@/composables/ai-onboarding/useAiStepSummaryConfig";
import {Steps} from "@/composables/ai-onboarding/useSteps";

const emit = defineEmits(['completeAutoAssignProcess']);

const triggerEvent = () => {
  emit('completeAutoAssignProcess');
}
</script>

<template>
  <div class="tailwind">
    <h3 class="tw-font-bold tw-mb-[31px] tw-mt-[35px] tw-text-grey-dark tw-leading-[50px] tw-tracking-[-0.042em] tw-text-4.5xl">
      Map your keywords to pages
    </h3>

    <div class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-text-center tw-w-full tw-overflow-hidden">
      <JobProcessingProgress
        :has-navigation-steps="false"
        data-url-path="/ajax/v2/strategy/auto-assign-jobs-progress"
        :ai-summary-url-path="Steps.AI_AUTO_ASSIGN_HOLDING.aiSummaryUrlPath"
        :job-percentage-weights="[10, 60]"
        :step-summary-config="StepSummaryConfig"
        @trigger-navigation-event="triggerEvent"
      />
    </div>
  </div>
</template>
